<template>
    <div class="manufacturer-hero bmw-bg" :class="manufacturer.name.toLowerCase().replace(' ', '_') + '-bg'">
        <div class="row">
            <div class="col-sm-6 d-none d-sm-block text-center" :style="manufacturerBackgroundImage"></div>
            <div class="col-12 col-sm-6 p-5 position-relative">
                <img class="shadow img-fluid manufacturer-logo" :src="this.baseUrl + manufacturer.logo_image" :alt="manufacturer.name + ' logo'" />
                <h1 class="mt-5 mb-4 ps-sm-5">{{ model.h1 }}</h1>
                <div v-html="model.range_description" class="fw-light ps-sm-5 title-text"></div>
            </div>
        </div>
    </div>
    <div class="container main-content">
        <slimline-reg-size-form :postcode="postcode" :options="sizeOptions" :image-base-path="tyreImagePath"></slimline-reg-size-form>
        <div v-if="popularTyreRanges.length > 0">
            <div class="row">
                <div class="col-12">
                    <h2 class="h3 mt-4 mb-2">Most popular {{ model.name }} Tyres</h2>
                    <hr class="hr-navy">
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-3" v-for="tyre, key in popularTyreRanges" :key="key">
                    <model-tyre
                        :tyre="tyre"
                        :tyre-image-path="tyreImagePath"
                        :brand-image-path="brandImagePath"
                    ></model-tyre>
                </div>
            </div>
        </div>
    </div>
    <br/>
    <br/>
</template>

<script>
    export default {
        props: ['manufacturer', 'model', 'tyreImagePath', 'brandImagePath', 'popularTyreRanges', 'sizeOptions', 'postcode'],
        mounted() {
			//removes loading placeholder - fixes CLS issues
            if (document.contains(document.querySelector('#loadingPlaceholder'))) {
			    document.querySelector('#loadingPlaceholder').style.display = 'none';
            }
        },
        computed: {
            manufacturerBackgroundImage() {
                let manufacturer_image = ('Backgrounds/etyres/Manufacturers/' + (this.manufacturer.slug) + '.jpg');
                return 'background: url(' + (this.tyreImagePath + manufacturer_image) + ') no-repeat; background-size: cover; height: 427px;';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .manufacturer-hero {
        background: #e9ecef !important;
        span {
            background-color: inherit !important;
        }
        .hero-img {
            max-width: 75%;
        }
    }
    .title-text {
        @media screen and (min-width: 1200px) {
            max-width: 450px;
        }
    }
    .manufacturer-logo {
        @media screen and (min-width: 576px) {
            max-width: 150px;
            position: absolute;
            left: -85px;
            top: 80px;
        }
    }
    .brand-image {
        max-width: 170px;
    }
    .main-content {
        .slimline {
            @media screen and (min-width: 992px) {
                margin-top: -35px !important;
            }
        }
    }
</style>